import React from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
const RelatedArticles = (article:any) => {   
     const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
     const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);  

  return (
           <section className="mt-4">
          <h2 className="text-xl font-bold mb-6">You May Also Like</h2>

{Array.isArray(article?.article?.storiesyoumayinterested) && article?.article?.storiesyoumayinterested?.length > 0 && article?.article?.storiesyoumayinterested?.map((item:any,index:any)=>{
    return(<div className={`rounded-lg shadow-md overflow-hidden mb-4 ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`} key={index}>
            <div className="flex flex-col md:flex-row">
              <div className="md:w-1/3">
               <Link id={item?.url}
                  to={`/news/${item?.url}`} className="">
                <img 
                  src={item?.image} 
                  alt="Related article" 
                  className="w-full h-48 md:h-full object-cover"
                /></Link>
              </div>
              <div className="px-2 py-2 md:w-2/3">
                <h5 className={`font-bold mb-0 ${fontSize === 'small' ? 'text-sm' : fontSize === 'large' ? 'text-xl' : 'text-md'}`}>
                  <Link id={item?.url}
                  to={`/news/${item?.url}`} className="">
                    {item?.name}
                  </Link>
                </h5>
             
                <Link id={item?.url}
                  to={`/news/${item?.url}`}
                  className="inline-block font-medium hover:text-blue-800">
                  Read More →
                </Link>
              </div>
            </div>
          </div>)
})}

          

        </section>
  )
}
export default RelatedArticles;